import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button } from "antd";
import { PlusOutlined, MailFilled } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const EmployeeUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });

  useEffect(() => {
    if (props.data) {
      props.data.mobilePhone =
        props.data.mobilePhone != null ? "+90" + props.data.mobilePhone : "";
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFinish = (values) => {
    if (values.mobilePhone == "+90          ") {
      values.mobilePhone = null;
    }
    RequestHandler.put(`/Employee`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        form.resetFields();
        if (props.onSuccess) props.onSuccess();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="employeeAdd"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item
            style={{ marginTop: "4%" }}
            label="Personel Adı"
            name="name"
            rules={[
              {
                required: true,
                message: "Lütfen Personel Adı alanını boş bırakmayın.",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="E-Posta Adresi"
            name="email"
            rules={[{ type: "email" }]}
          >
            <Input type={MailFilled} />
          </Form.Item>
          <Form.Item
            label="T.C. Kimlik No"
            name="tcNo"
            rules={[
              {
                min: 11,
                message: "TcNo 11 karakter olmalıdır.",
              },
            ]}
          >
            <Input
              type="text"
              autoComplete="off"
              onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
              maxLength="11"
              onInput={maxLengthCheck}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
          </Form.Item>

          <Form.Item
            label="Cep Numarası"
            name="mobilePhone"
            rules={[
              {
                min: 12,
                message: "Telefon numarasını eksiksiz giriniz.",
              },
            ]}
          >
            <PhoneInput
              inputStyle={{ width: "100%" }}
              country="tr"
              masks={{ tr: "(...) ...-..-.." }}
            />
          </Form.Item>
          <Form.Item
            label="Iban"
            name="iban"
            rules={[
              {
                required: true,
                message: "Lütfen Iban alanını boş bırakmayın.",
              },
            ]}
          >
            <Input
              type="text"
              onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()}
              maxLength="26"
            />
          </Form.Item>

          <Row justify="space-between">
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Güncelle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default EmployeeUpdateForm;
